import React from 'react';
import DailySpin from './DailySpin';
import useDailySpinContainer from 'shared/screens/DailySpin/hooks/useDailySpinContainer';

const DailySpinContainer = props => {
  const { bonusRes, dailyWheelAssets } = useDailySpinContainer(props);

  return bonusRes && dailyWheelAssets ? (
    <DailySpin {...props} dailyWheelAssets={dailyWheelAssets} bonusRes={bonusRes} />
  ) : (
    false
  );
};

export default DailySpinContainer;

DailySpinContainer.hideDefaultBackground = true;
DailySpinContainer.hideCloseButton = true;
DailySpinContainer.hideOverlay = true;
DailySpinContainer.AsModalProps = {
  style: {
    padding: 0,
  },
  dialogClassName: 'gtp-modal-dailybonus',
};
